import getSource from './getSource'

const getValues = (brand) => {
  if (brand === 'kinto') {
    return {
      eventName: 'new-formevent',
      eventComponentGroup: 'services',
    }
  }

  return {
    eventName: 'formevent',
    eventComponentGroup: 'forms',
  }
}

/* eslint-disable no-console */
const formEvent = (data, brand) => {
  window.tngaDataLayer.form = {
    name: data.name,
    step: data.action || data.step,
    conversion: data.conversion,
    variant: data.variant,
    source: getSource() || '(national site)',
  }
  window.tngaDataLayer.event = {
    name: getValues(brand).eventName,
    componentName: data.page || data.name,
    componentGroup: getValues(brand).eventComponentGroup,
    action: data.action || 'form-step',
    label: data.step,
  }
  window.dataLayer?.push({
    event: getValues(brand).eventName,
  })

  const savedEvent = { ...window.tngaDataLayer }

  console.log(`${getValues(brand).eventName} triggered`, savedEvent)
}

const workflowEvent = (data) => {
  window.tngaDataLayer.workflow = {
    name: data.name || data.page,
    step: data.step,
    conversion: data.conversion,
    variant: data.variant,
    source: getSource() || '(national site)',
  }
  window.tngaDataLayer.event = {
    name: 'workflowevent',
    componentName: data.page || data.name,
    componentGroup: 'tools',
    action: data.action,
    label: data.step,
  }
  window.dataLayer?.push({
    event: 'workflowevent',
  })

  const savedEvent = { ...window.tngaDataLayer }

  console.log('workflowevent triggered', savedEvent)
}

const customEvent = (data) => {
  // TME advised to disable input interaction
  if (!data.action.includes('interaction')) {
    window.tngaDataLayer.event = {
      name: data.name,
      componentName: data.componentName,
      componentGroup: data.componentGroup,
      action: data.action,
      label: data.label,
      variant: data.variant,
    }

    window.tngaDataLayer.workflow = {}

    window.dataLayer?.push({
      event: data.name,
    })

    const savedEvent = { ...window.tngaDataLayer }

    console.log(`${data.name} triggered`, savedEvent)
  }
}

const updateDatalayer = (object, data) => {
  // Dealer
  if (object === 'dealer') {
    if (data) {
      window.tngaDataLayer.dealer = {
        city: data.address.city,
        dealerId: data.uuid,
        name: data.name,
        zipcode: data.address.zip,
      }
    } else {
      window.tngaDataLayer.dealer = {}
    }
  }

  // Dealer group
  if (object === 'group') {
    if (data) {
      window.tngaDataLayer.dealer = {
        dealerId: data.uuid,
        name: data.name,
      }
    } else {
      window.tngaDataLayer.dealer = {}
    }
  }

  // Non kinto forms with models
  if (object === 'model') {
    if (data) {
      window.tngaDataLayer.product = [
        {
          category: 'cars',
          productInfo: {
            modelName: data.name,
            tmeModelId: data.id,
          },
          subCategory: 'new-cars',
        },
      ]
    } else {
      window.tngaDataLayer.product = [{}]
    }
  }

  if (object === 'model-qfc') {
    if (data) {
      window.tngaDataLayer.product = [
        {
          category: 'cars',
          productInfo: {
            modelName: data.name,
            tmeModelId: data.id,
            productId: data.productId,
            productName: data.productName,
          },
          subCategory: 'new-cars',
        },
      ]
    } else {
      window.tngaDataLayer.product = [{}]
    }
  }

  // Kinto forms with models
  if (data.brand === 'kinto' && object === 'model') {
    if (data) {
      window.tngaDataLayer.product = [
        {
          category: 'services',
          productInfo: {
            productName: data.service,
            modelName: data.name,
            manufacturerName: data.manufacturer,
          },
          subCategory: 'kinto-mobility',
        },
      ]
    } else {
      window.tngaDataLayer.product = [{}]
    }
  }

  // Kinto forms with service
  if (data.brand === 'kinto' && object === 'service') {
    if (data) {
      window.tngaDataLayer.product = [
        {
          category: 'services',
          productInfo: {
            productName: data.service,
          },
          subCategory: 'kinto-mobility',
        },
      ]
    } else {
      window.tngaDataLayer.product = [{}]
    }
  }
}

const getEvent = (e) => {
  if (e.target.dataset.gtAction) {
    const el = e.target

    const tracking = {
      name: el.closest('[data-gt-name]')?.dataset.gtName || '',
      componentName:
        el.closest('[data-gt-componentname]')?.dataset.gtComponentname || '',
      componentGroup:
        el.closest('[data-gt-componentgroup]')?.dataset.gtComponentgroup || '',
      action: el.closest('[data-gt-action]')?.dataset.gtAction || '',
      label: el.closest('[data-gt-label]')?.dataset.gtLabel || '',
    }

    customEvent(tracking)
  }
}

const initTracking = (active: boolean) => {
  if (active) {
    window.addEventListener('click', getEvent, false)
  } else {
    window.removeEventListener('click', getEvent, false)
  }
}

const tracking = {
  componentGroup: () => {
    return typeof window !== 'undefined'
      ? document.body.dataset?.gtComponentgroup
      : 'forms'
  },
  componentName: () => {
    return typeof window !== 'undefined'
      ? document.body.dataset?.gtComponentname
      : ''
  },
}

export {
  customEvent,
  formEvent,
  initTracking,
  tracking,
  updateDatalayer,
  workflowEvent,
}
